"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseApiClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const ApiErrorSerializers_1 = require("@deliverr/commons-logs/lib/ApiErrorSerializers");
const errors_1 = require("@deliverr/errors");
const WarehouseErrorCode_1 = require("./WarehouseErrorCode");
class WarehouseApiClient extends base_client_1.ApiClient {
    constructor(config = {}) {
        super(config);
    }
    handleError(fn, ex, warehouseId = "", value = "") {
        if (!ex.response) {
            commons_logs_1.log.error(`${fn} error occurred ${ex}`);
            throw ex;
        }
        const receivedDeliverrError = this.maybeGetDeliverrError(ex);
        if (ex.response.status === 404 && !receivedDeliverrError) {
            commons_logs_1.log.info(`${fn}: not found: ${warehouseId}, ${value}`);
            return undefined;
        }
        throw (receivedDeliverrError ||
            this.maybeWarehouseNetworkError(ex) ||
            this.maybeGetNetworkError(ex) ||
            this.getUnknownError(ex));
    }
    maybeWarehouseNetworkError(ex) {
        if (ex.response.status === 503 || ex.response.status === 504) {
            return new errors_1.DeliverrError({
                code: WarehouseErrorCode_1.WarehouseErrorCode.NETWORK_ERR,
                payload: (0, ApiErrorSerializers_1.apiErrorSerializer)(ex),
            });
        }
        return undefined;
    }
}
exports.WarehouseApiClient = WarehouseApiClient;
//# sourceMappingURL=WarehouseApiClient.js.map